// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  border-top: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-bottom: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  background: var(--randy-red-dark);
  line-height: var(--quantity-selector-height);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.quantity-selector > *:first-child {
  border-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
}
.quantity-selector > *:last-child {
  border-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  border-radius: 50%;
  color: #fff;
}

.rectangle {
  background: transparent !important;
  color: #1E1E1C;
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  font-family: AppFontSemiBold;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
}

.minus {
  height: 2px;
  width: 15px;
}

.plus {
  height: 14.5px;
  width: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;AACD;AACC;EACC,6FAAA;EACA,gGAAA;EACA,iCAAA;EACA,4CAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACC,8FAAA;AAAH;AAGE;EACC,+FAAA;AADH;;AAMA;EACC,sCAAA;EACA,uCAAA;EACA,eAAA;EACG,kBAAA;EACA,WAAA;AAHJ;;AAMA;EACC,kCAAA;EACA,cAAA;EACA,gDAAA;EACA,uCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAJD;;AAOA;EACC,WAAA;EACA,WAAA;AAJD;;AAMA;EACE,cAAA;EACA,WAAA;AAHF","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n\n\t> * {\n\t\tborder-top: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\tborder-bottom: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\tbackground: var(--randy-red-dark);\n\t\tline-height: var(--quantity-selector-height);\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t&:first-child {\n\t\t\tborder-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n        }\n\n\t\t&:last-child {\n\t\t\tborder-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n        }\n\t}\n}\n\n.circle {\n\twidth: var(--quantity-selector-height);\n\theight: var(--quantity-selector-height);\n\tcursor: pointer;\n    border-radius: 50%;\n    color: #fff;\n}\n\n.rectangle {\n\tbackground: transparent !important;\n\tcolor: #1E1E1C;\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n\n\tfont-family: AppFontSemiBold;\n\tfont-size: var(--quantity-font-size);\n\tline-height: 28.8px;\n\ttext-align: center;\n}\n\n.minus {\n\theight: 2px;\n\twidth: 15px;\n}\n.plus {\n  height: 14.5px;\n  width: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
